import { Group, Select } from '@mantine/core';
import { UserRole, UserStatus, USER_ROLES, USER_STATUSES } from '../types';
import { roleAsDisplayName, statusAsDisplayName } from '../utils';

interface FilterRowDropdownsProps {
  selectedStatus: UserStatus | null;
  setSelectedStatus: (status: UserStatus | null) => void;
  selectedRole: UserRole | null;
  setSelectedRole: (role: UserRole | null) => void;
}

export function FilterRowDropdowns({
  selectedStatus,
  setSelectedStatus,
  selectedRole,
  setSelectedRole,
}: FilterRowDropdownsProps) {
  return (
    <Group grow>
      <Select
        label="Status"
        placeholder="Select status"
        data={USER_STATUSES.map(status => ({ label: statusAsDisplayName(status), value: status }))}
        value={selectedStatus}
        onChange={value => setSelectedStatus((value as UserStatus) || null)}
      />
      <Select
        label="Role"
        placeholder="Select role"
        data={USER_ROLES.map(role => ({ label: roleAsDisplayName(role), value: role }))}
        value={selectedRole}
        onChange={value => setSelectedRole((value as UserRole) || null)}
      />
    </Group>
  );
}
